import { createContext, useContext } from 'react';

export const DocumentsContext = createContext({});

const useDocumentsContext = () => useContext(DocumentsContext);

export default useDocumentsContext;
